{
  "version": 1,
  "asset_id": "67248e3b-0b6c-4217-b236-b3f71f64513b",
  "project_id": "97176789-536c-4447-900d-52ecbc24e875",
  "url": "/__l5e/assets-v1/67248e3b-0b6c-4217-b236-b3f71f64513b/leaders-come-in-all-sizes.png",
  "r2_key": "a/v1/97176789-536c-4447-900d-52ecbc24e875/67248e3b-0b6c-4217-b236-b3f71f64513b/leaders-come-in-all-sizes.png",
  "original_filename": "leaders-come-in-all-sizes.png",
  "size": 2027934,
  "content_type": "image/png",
  "created_at": "2026-09-29T13:45:58Z"
}
